import { render, staticRenderFns } from "./StatConstructorContainer.vue?vue&type=template&id=37353f13&scoped=true&"
import script from "./StatConstructorContainer.vue?vue&type=script&lang=js&"
export * from "./StatConstructorContainer.vue?vue&type=script&lang=js&"
import style0 from "./StatConstructorContainer.vue?vue&type=style&index=0&id=37353f13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37353f13",
  null
  
)

export default component.exports